module.exports = __webpack_public_path__ + "img/9791187206224.e1a87aed.jpg";